import * as React from "react"

import Seo from "../components/seo";
import Header from '../components/Header';
import Banner from '../components/Banner';
import Steps from '../components/Steps';
import Mentioned from '../components/Mentioned';
import Separator from '../components/Separator';
import CompletelySafe from '../components/CompletelySafe';
import Trustpilot from '../components/Trustpilot';
import Footer from '../components/Footer';

import GlobalStyle from '../styles/global';
import * as S from '../styles/index';

const Index = () => {
  const [isModal, setModal] = React.useState(false);

  function onCloseModal(){
    setModal(false);
  }

  return (
    <S.Container>
      <Seo title="Home" description="Talent Juice is the best way to monetize your content that you share on social media." />
      <GlobalStyle />
      <Header setModal={setModal} />
      <Banner setModal={setModal} />
      <Separator text="How does it work ?" />
      <Steps />
      <Mentioned />
      <Separator text={<Trustpilot />} />
      <CompletelySafe />
      <Footer setModal={setModal} />
      {isModal && 
      <S.Modal onClick={() => onCloseModal()}>
        <S.ModalContainer>
          <h3>Are you an influencer or Are you an advertiser ?</h3>
          <ul>
            <li className="spotlight"><a rel="noreferrer" href="#">Influencer</a></li>
            <li className="spotlight"><a rel="noreferrer" href="#">Advertiser</a></li>
          </ul>
        </S.ModalContainer>
      </S.Modal>}
      <script
        dangerouslySetInnerHTML={{
          __html: `
          var Tawk_API=Tawk_API||{}, Tawk_LoadStart=new Date();
          (function(){
          var s1=document.createElement("script"),s0=document.getElementsByTagName("script")[0];
          s1.async=true;
          s1.src='https://embed.tawk.to/6143775425797d7a89ff59e4/1ffnok9ak';
          s1.charset='UTF-8';
          s1.setAttribute('crossorigin','*');
          s0.parentNode.insertBefore(s1,s0);
          })();
              `,
        }}
      />
    </S.Container>
  );
}

export default Index;
